import { Chip, Container, MenuItem, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { getAllStaff } from '../../actions/Team/team.actions'
import {
	getVisitById,
	updateVisit,
	postVisit,
	deleteVisit,
	getVisitsByFacilityId
} from '../../actions/visits/visits.actions'
import { showError } from '../../actions/misc/misc.actions'
import { EditAppointmentDetailsDialog } from '../../components/Dialogs'
import CancelDeleteVisitDialog from '../../components/Dialogs/Visit/CancelDeleteVisitDialog'
import EditDogsDialog from '../../components/Dialogs/Visit/EditDogsDialog'
import RemovedAddOnsDialog from '../../components/Dialogs/Visit/RemovedAddOnsDialog'
import DuplicateDialog from '../../components/Dialogs/Visit/DuplicateDialog'
import EditLineItemDialog from '../../components/Dialogs/Visit/EditLineItemDialog'
import ErrorCode from '../../components/Misc/ErrorCode'
import EditVisitDropdown from '../../components/Pets/EditVisitDropdown'
import VisitPetDetail from '../../components/Pets/VisitPetDetail'
import VisitDetailsCard from '../../components/Visits/VisitDetailsCard'
import VisitInvoiceCard from '../../components/Visits/VisitInvoiceCard'
import OldVisitInvoiceCard from '../../components/Visits/OldVisitInvoiceCard'
import AddToDropoffPickupQueueDialog from '../../components/Dialogs/Visit/AddToDropoffPickupQueueDialog'
import { enumerateDaysBetweenDates, getChipStyles, matchPetsToVisit } from '../../services/helpers'
import {
	STATUS_ID,
	PLACEHOLDER_DATE,
	filterAddOnsByTimeBlock,
	BOARDING,
	DAYCARE,
	GROOMING,
	ADDON_ONLY
} from '../../utils'
import Loading from '../common/Loading'
import { WIZARD_INDENTIFIERS } from '../../components/Wizards/constants'
import GroomingAppointmentWizard from '../../components/Wizards/Grooming/GroomingAppointmentWizard'
import DaycareWizard from '../../components/Wizards/Daycare'
import BoardingWizard from '../../components/Wizards/Boarding'
import useCurrentUser from '../../hooks/useCurrentUser'
import useConstants from '../../hooks/useConstants'

const useStyles = makeStyles(() => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px'
	},
	statusChip: {
		marginLeft: 16,
		'& .MuiChip-label': {
			marginRight: 0
		}
	}
}))

let gen // setting up a generator here to be used across components/renders

const Visit = () => {
	const useQuery = () => {
		const { search } = useLocation()

		return useMemo(() => new URLSearchParams(search), [search])
	}

	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	// const constants = useSelector((state) => state.general.constants.constants)
	const visit = useSelector((state) => state.specific.visits.selected)
	const visits = useSelector((state) => state.specific.visits.visits)
	const loading = useSelector((state) => state.specific.visits.loading)
	const error = useSelector((state) => state.specific.visits.error)
	const pets = useSelector((state) => state.specific.visits.pets)
	const household = useSelector((state) => state.specific.households.selected)
	const facilities = useSelector((state) => state.specific.facilities.facilities)
	let facility = facilities?.find((f) => f._id === visit?.facility_id)
	// const addOns = useSelector((state) => state.specific.visits.selected?.add_on_services)
	const staffList = useSelector((state) => state.specific.team.staffList)
	const history = useHistory()
	const query = useQuery()
	const [isShown, setIsShown] = useState(false)
	// const [isGroomingShown, setIsGroomingShown] = useState(false)
	const [isCancelDeleteDialogShown, setIsCancelDeleteDialogIsShown] = useState(false)
	const [isEditPetsDialogShown, setIsEditPetsDialogIsShown] = useState(false)
	const [isAddPet, setIsAddPet] = useState(false)
	const [updatedVisit, setUpdatedVisit] = useState(null)
	const [isEditItemPopupShown, setIsEditItemPopupShown] = useState(false)
	const [editPromo, setEditPromo] = useState(false)
	const [selectedItem, setSelectedItem] = useState(false)
	const [duplicateDialog, setDuplicateDialog] = useState(false)
	const [groomingAppointmentWizardOpen, setGroomingAppointmentWizardOpen] = useState(false)
	const [groomingAppointmentWizardStep, setGroomingAppointmentWizardStep] = useState(0)
	const [daycareWizardOpen, setDaycareWizardOpen] = useState(false)
	const [daycareWizardStep, setDaycareWizardStep] = useState(0)
	const [boardingWizardOpen, setBoardingWizardOpen] = useState(false)
	const [boardingWizardStep, setBoardingWizardStep] = useState(0)
	const [isRebook, setIsRebook] = useState(false)
	const [removedAddons, setRemovedAddOns] = useState([])
	const [removedAddOnsWarning, showRemovedAddOnsWarning] = useState(false)
	const [showAddToDPQueueDialog, setShowAddToDPQueueDialog] = useState(false)
	let [mapped_facility, setMappedFacility] = useState(null)

	const { appointmentStatuses } = useConstants()
	const { isBackOfficeUser, isPcaSupervisorUser } = useCurrentUser()

	const isAddOnGroomingVisitOnly = visit?.type === ADDON_ONLY && visit?.subtype === GROOMING

	const date = moment().format('YYYY-MM-DD')

	const addOns = useMemo(() => {
		if (visit?.add_on_services) {
			return visit.add_on_services
		}

		return []
	}, visit)

	// Load the day's visits once per facility and day. Refetching whenever the list was empty
	// looped forever at a facility with no visits that day: each empty result is a new array.
	const fetchedVisitsKey = useRef(null)
	useEffect(() => {
		const key = facility?._id ? `${facility._id}:${date}` : null
		if (key && !visits?.length && visit?.dates?.includes(date) && fetchedVisitsKey.current !== key) {
			fetchedVisitsKey.current = key
			dispatch(getVisitsByFacilityId(facility, date))
		}
	}, [facility, visit, visits])

	useEffect(() => {
		let pricing_table_id = visit?.pricing_table
		if (pricing_table_id && facility) {
			let pricing_table = facility?.historical_prices?.find((p) => p._id === pricing_table_id)
			if (pricing_table) {
				let fac = {
					...facility,
					pricing_table_id,
					compatibility_session_price:
						pricing_table.compatibility.prices.compatibility_session_price ||
						facility.compatibility_session_price ||
						1000,
					services: {
						...facility.services,
						daycare: {
							...facility.services.daycare,
							...pricing_table.daycare
						},
						boarding: {
							...facility.services.boarding,
							...pricing_table.boarding.prices
						}
					}
				}

				setMappedFacility(fac)
			}
		} else if (facility) {
			setMappedFacility(facility)
		}
	}, [facility, visit])

	const isGrooming = useMemo(() => {
		if (!visit) {
			return false
		}
		return visit.type === GROOMING
	}, [visit])

	const isDaycare = useMemo(() => {
		if (!visit) {
			return false
		}
		return visit.type === DAYCARE
	}, [visit])

	const isBoarding = useMemo(() => {
		if (!visit) {
			return false
		}
		return visit.type === BOARDING
	}, [visit])

	const canBeAddedToDropoffPickupQueue =
		[STATUS_ID.Approved, STATUS_ID.InProgress].includes(visit?.status?.id) && (isDaycare || isBoarding)

	useEffect(() => {
		if (!staffList || !staffList.length) dispatch(getAllStaff())
	}, [])

	useEffect(() => {
		if (!visit || visit._id !== params.visitId) {
			// console.log('visitId !visit || visit._id !== params.visitId')
			dispatch(getVisitById(params.visitId))
		} else {
			setUpdatedVisit(matchPetsToVisit(visit, pets))
		}
	}, [visit])

	useEffect(() => {
		const withWizardId = query.get('wizard')
		const step = query.get('step')
		const isARebook = query.get('isRebook')
		if (isGrooming && withWizardId === WIZARD_INDENTIFIERS.GroomingAppointment) {
			setGroomingAppointmentWizardOpen(true)
			setGroomingAppointmentWizardStep(step || 0)
			if (isARebook) {
				setIsRebook(true)
			}
			return
		}

		// Daycare and Boarding wizards only available for pending appointments
		if (
			isDaycare &&
			withWizardId === WIZARD_INDENTIFIERS.DaycareAppointment &&
			visit.status.id < STATUS_ID.Approved
		) {
			setDaycareWizardOpen(true)
			setDaycareWizardStep(step || 0)
			return
		}

		if (
			isBoarding &&
			withWizardId === WIZARD_INDENTIFIERS.BoardingAppointment &&
			visit.status.id < STATUS_ID.Approved
		) {
			setBoardingWizardOpen(true)
			setBoardingWizardStep(step || 0)
			return
		}
	}, [query, isGrooming, isDaycare, isBoarding, visit])

	const handleDaycareAppointmentWizardClose = useCallback(() => {
		setDaycareWizardOpen(false)
	}, [])

	const handleBoardingAppointmentWizardClose = useCallback(() => {
		setBoardingWizardOpen(false)
	}, [])

	const handleGroomingAppointmentWizardClose = useCallback(() => {
		// setUpdatedVisit(matchPetsToVisit(visit, pets))
		setGroomingAppointmentWizardOpen(false)
	}, [visit])

	const removeVisit = () => {
		dispatch(deleteVisit({ visit_id: visit._id })).then(() => {
			let originalDate = query.get('date')
			history.push(`/facilities/${facility._id}/schedule${originalDate ? `?date=${originalDate}` : ''}`)
		})
	}

	const cancelVisit = () => {
		const updates = {}
		if (visit.status && visit.status.id !== STATUS_ID.Completed && visit.status.id !== STATUS_ID.Cancelled) {
			updates.status = appointmentStatuses.find(
				(appointmentStatus) => appointmentStatus.id === STATUS_ID.Cancelled
			)
		}

		dispatch(updateVisit({ visit_id: visit._id, updates: updates })).then(() => {
			setIsCancelDeleteDialogIsShown(false)
		})
	}

	// this is complicated because boarding visits can be edited and end up having 'impossible' addons,
	// which then get removed on the API side. Need to check for these and then save the visit after user confirms
	const series = (...rest) => {
		if (visit.type === BOARDING) {
			// set the generator with the params for saving the visit, which it caches
			gen = checkForRemovedAddOns(...rest)
			// invoke the first generator yield, which doesn't do anything, just 'starts' it
			gen.next()
			// get the value of the next yield, which is the removed addons
			let removed_adds = gen.next().value
			if (removed_adds.length) {
				setRemovedAddOns(removed_adds)
				showRemovedAddOnsWarning(true)
				dispatch({ type: 'UPDATE_VISIT_FAIL' })
				return
			} else {
				gen.next()
			}
		} else {
			saveVisit(...rest)
		}
	}

	// generator function that calls the 'saveVisit' first to check for any addons that will be removed due to date/time changes
	function* checkForRemovedAddOns(...rest) {
		yield 'whatever'
		yield saveVisit(...rest, true)
		yield saveVisit(...rest)
	}

	const saveVisit = (
		visitTypeHasChanged = false,
		newVisitType,
		startDate,
		endDate,
		status,
		extendedPickup,
		earlyDropOff,
		chargeFee,
		customFee,
		dropOffTime,
		pickUpStartTime,
		pickUpEndTime,
		firstDayDaycare,
		lastDayDaycare,
		sharingKennel,
		showOldInvoice,
		boardingOptions,
		returnRemovedAddOns
	) => {
		const dates = endDate
			? enumerateDaysBetweenDates(startDate, endDate)
			: [moment(startDate).format('YYYY-MM-DD')]

		dispatch({ type: 'UPDATE_VISIT' })

		let updates = {
			startDate: startDate,
			visit_date: startDate,
			dates,
			extended_pickup: extendedPickup,
			early_dropoff: earlyDropOff,
			fee_type: chargeFee,
			fee_amount: customFee,
			dropoff_time: dropOffTime ? dropOffTime.format('HH:mm') : null,
			pickup_time: pickUpStartTime ? pickUpStartTime.format('HH:mm') : null,
			pickup_end_time: pickUpEndTime ? pickUpEndTime.format('HH:mm') : null,
			first_day_daycare: firstDayDaycare,
			last_day_daycare: lastDayDaycare,
			sharing_kennels: sharingKennel,
			show_old_invoice: showOldInvoice
		}

		if (boardingOptions) {
			updates.boarding_options = boardingOptions
		}

		if (endDate && visit.type === BOARDING) {
			updates.endDate = endDate
		} else if (visit.type !== BOARDING) {
			updates.endDate = startDate
		}

		if (visitTypeHasChanged) {
			updates.type = newVisitType
			if (newVisitType === BOARDING) {
				updates.endDate = endDate
			}
			if (newVisitType === DAYCARE) {
				updates.endDate = startDate
			}
		}

		if (returnRemovedAddOns) {
			const removed_addons = visit?.add_on_services?.filter((a) => {
				let allowed = filterAddOnsByTimeBlock(a, {
					...updates,
					allowedTimeBlocks: visit.allowedTimeBlocks,
					type: visit.type,
					visitTypeHasChanged,
					newVisitType
				})
				return !allowed
			})

			return removed_addons
		}

		if (dates.length < visit.dates.length && visit.deposit_paid) {
			if (!isBackOfficeUser && !isPcaSupervisorUser) {
				dispatch(showError('You cannot shorten the duration of this appointment due to deposit.'))
				dispatch({ type: 'UPDATE_VISIT_FAIL' })
				return
			}
		}

		if (visit.status && status && visit.status.id !== status.id) {
			updates.status = status
		}
		dispatch(updateVisit({ visit_id: visit._id, updates: updates })).then(() => {
			setIsShown(false)
		})
	}

	const editDogsOnVisit = (petIds) => {
		let uniquePets = [...new Set(petIds)]
		let updates = {
			startDate: visit.startDate,
			endDate: visit.type === BOARDING ? visit.endDate : null,
			dates: visit.dates ? visit.dates : [moment(visit.startDate).format('YYYY-MM-DD')],
			pet_ids: uniquePets
		}
		dispatch(updateVisit({ visit_id: visit._id, updates: updates })).then(() => {
			setIsShown(false)
		})
	}

	const getDate = (visit) => {
		let start = visit.startDate ? moment(visit.startDate) : null
		let end = visit.type === BOARDING && visit.endDate ? moment(visit.endDate) : moment(visit.startDate)
		if (start && end) {
			let startDay = start.format('D')
			let endDay = end.format('D')
			let startMonth = start.format('MMM')
			let endMonth = end.format('MMM')
			let endDateDisplay = ''
			if (visit.type === BOARDING) {
				endDateDisplay =
					startMonth === endMonth && endDay
						? ` - ${endDay}`
						: startMonth !== endMonth && endDay
						? ` - ${endMonth} ${endDay}`
						: null
			}
			return `${startMonth} ${startDay}${endDateDisplay}`
		}
	}

	const updateVisitPrice = async (updates) => {
		let body = {
			visit_id: visit._id,
			updates: {
				...updates
			}
		}

		dispatch(updateVisit(body, true))
	}

	const duplicateGroomingVisit = () => {
		try {
			const {
				grooming_service_type = '',
				hair_length = '',
				trim_amount = '',
				notes_from_client = '',
				matted = '',
				reference_photo_url = '',
				pets = [],
				household_id,
				facility_id,
				pet_ids = [],
				add_on_services = []
			} = updatedVisit

			const newVisit = {
				household_id,
				facility_id,
				type: GROOMING,
				grooming_service_type,
				hair_length,
				trim_amount,
				notes_from_client,
				matted,
				reference_photo_url,
				pets,
				pet_ids,
				status: {
					id: STATUS_ID.Pending,
					name: 'Pending'
				},
				addons_to_duplicate: add_on_services,
				startDate: PLACEHOLDER_DATE,
				dates: [PLACEHOLDER_DATE],
				endDate: PLACEHOLDER_DATE
			}

			dispatch(
				postVisit(newVisit, (visit) =>
					openTab({
						newVisit: visit,
						wizardId: WIZARD_INDENTIFIERS.GroomingAppointment,
						isRebook: true
					})
				)
			)
		} catch (e) {
			console.log('err...', e.toString())
		}
	}

	const duplicateVisit = (date) => {
		try {
			const newVisit = {
				...updatedVisit,
				dates: [date.format('YYYY-MM-DD')],
				startDate: moment(date).hour(12).toDate(),
				endDate: moment(date).hour(12).toDate(),
				visit_date: moment(date).hour(12).toDate(),
				status: {
					id: STATUS_ID.Pending,
					name: 'Pending'
				},
				addons_to_duplicate: updatedVisit.add_on_services,
				pet_status: [],
				reports: []
			}

			delete newVisit.staff_id
			delete newVisit.dropoff_time
			delete newVisit.pickup_time
			delete newVisit.pickup_time_end
			delete newVisit.start_time
			delete newVisit._id
			delete newVisit.checkin_time
			delete newVisit.grooming_actual_start_time
			delete newVisit.grooming_actual_end_time
			delete newVisit.grooming_team_report_notes
			delete newVisit.behavior_notes
			delete newVisit.grooming_client_report_notes
			delete newVisit.before_photo_url
			delete newVisit.after_photo_url
			delete newVisit.grooming_report_sent
			delete newVisit.grooming_report_viewed
			delete newVisit.grooming_status
			delete newVisit.grooming_report_sent_time
			dispatch(postVisit(newVisit, (visit) => openTab({ newVisit: visit })))
		} catch (e) {
			console.log('err...', e.toString())
		}
	}

	const openTab = ({ newVisit, wizardId, isRebook = false }) => {
		let base =
			process.env.REACT_APP_ENV === 'production'
				? 'https://admin-petcare.herokuapp.com'
				: 'https://admin-petcare-staging.herokuapp.com'

		let url = `/clients/${newVisit.household_id}/appointments/${newVisit._id}`
		if (wizardId && wizardId > '') {
			url += `?wizard=${wizardId}`
			if (isRebook) {
				url += '&isRebook=true'
			}
		}
		window.open(`${base}${url}`, '_blank')
	}

	return (
		<Container
			className={classes.root}
			style={{
				paddingLeft: '20px !important',
				paddingRight: '20px !important'
			}}
			maxWidth="md">
			{isGrooming ? (
				<GroomingAppointmentWizard
					open={groomingAppointmentWizardOpen}
					step={groomingAppointmentWizardStep}
					updatedVisit={updatedVisit}
					onClose={handleGroomingAppointmentWizardClose}
					isRebook={isRebook}
				/>
			) : null}
			{isDaycare ? (
				<DaycareWizard
					open={daycareWizardOpen}
					step={daycareWizardStep}
					onClose={handleDaycareAppointmentWizardClose}
					updatedVisit={updatedVisit}
				/>
			) : null}
			{isBoarding ? (
				<BoardingWizard
					open={boardingWizardOpen}
					step={boardingWizardStep}
					onClose={handleBoardingAppointmentWizardClose}
					updatedVisit={updatedVisit}
				/>
			) : null}
			{updatedVisit &&
			!loading &&
			!groomingAppointmentWizardOpen &&
			!daycareWizardOpen &&
			!boardingWizardOpen ? (
				<div>
					<div
						style={{
							width: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between'
						}}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<Typography variant="h5" style={{ fontWeight: 800 }}>
								{getDate(updatedVisit) + ' Appointment'}
							</Typography>
							{updatedVisit.status ? (
								<Chip
									className={classes.statusChip}
									label={updatedVisit.status.name}
									style={getChipStyles(updatedVisit.status.name)}
								/>
							) : null}
						</div>
						<EditVisitDropdown>
							{((updatedVisit.status.id !== STATUS_ID.Cancelled &&
								updatedVisit.status.id !== STATUS_ID['No Show']) ||
								updatedVisit.type === GROOMING) && (
								<section>
									{![STATUS_ID.Cancelled, STATUS_ID['No Show']].includes(
										updatedVisit.status.id
									) && (
										<MenuItem
											onClick={() => {
												setIsShown(true)
											}}>
											Edit Appointment
										</MenuItem>
									)}
									{updatedVisit.type !== GROOMING && !isAddOnGroomingVisitOnly && (
										<React.Fragment>
											<MenuItem
												onClick={() => {
													setIsEditPetsDialogIsShown(true)
													setIsAddPet(true)
												}}>
												Add Pets
											</MenuItem>
											<MenuItem
												onClick={() => {
													setIsEditPetsDialogIsShown(true)
													setIsAddPet(false)
												}}>
												Remove Pets
											</MenuItem>
										</React.Fragment>
									)}
									{canBeAddedToDropoffPickupQueue ? (
										<>
											<MenuItem
												onClick={() => {
													setShowAddToDPQueueDialog(true)
												}}>
												Add to I'm Here Queue
											</MenuItem>
										</>
									) : null}
									{updatedVisit.type === GROOMING && (
										<React.Fragment>
											<MenuItem
												onClick={() => {
													duplicateGroomingVisit()
												}}>
												Re-Book Appointment
											</MenuItem>
										</React.Fragment>
									)}
								</section>
							)}
							{(updatedVisit.status.id === STATUS_ID.Cancelled ||
								updatedVisit.status.id === STATUS_ID['No Show']) && (
								<MenuItem
									onClick={() => {
										setIsCancelDeleteDialogIsShown(true)
									}}>
									Delete Appointment
								</MenuItem>
							)}
						</EditVisitDropdown>
					</div>
					<VisitDetailsCard
						visit={updatedVisit}
						date={getDate(updatedVisit)}
						addOns={addOns}
						hasRelatedPetCareVisit={!!visit?.related_petcare_visit}
					/>

					{updatedVisit.pets && updatedVisit.pets.length > 0 ? (
						updatedVisit.pets.map((pet) => (
							<VisitPetDetail
								key={pet._id}
								pet={pet}
								household={household}
								facility={facility}
								visits={visits}
								visit={updatedVisit}
								staffList={staffList}
							/>
						))
					) : (
						<Typography>No pets</Typography>
					)}
					{updatedVisit.show_old_invoice ? (
						<OldVisitInvoiceCard
							visit={updatedVisit}
							facility={mapped_facility}
							addOnBank={household?.addon_bank}
							isEditItemPopupShown={isEditItemPopupShown}
							setIsEditItemPopupShown={setIsEditItemPopupShown}
							selectedItem={selectedItem}
							setSelectedItem={setSelectedItem}
						/>
					) : (
						<VisitInvoiceCard
							visit={updatedVisit}
							setEditPromo={setEditPromo}
							facility={mapped_facility}
							addOnBank={household?.addon_bank}
							isEditItemPopupShown={isEditItemPopupShown}
							setIsEditItemPopupShown={setIsEditItemPopupShown}
							selectedItem={selectedItem}
							setSelectedItem={setSelectedItem}
						/>
					)}
				</div>
			) : null}
			{loading || !updatedVisit ? <Loading /> : null}
			{error && !updatedVisit ? <ErrorCode error={error} /> : null}
			{updatedVisit && !groomingAppointmentWizardOpen ? (
				<div>
					<EditAppointmentDetailsDialog
						visit={updatedVisit}
						facility={mapped_facility}
						first_day_daycare={updatedVisit.first_day_daycare}
						last_day_daycare={updatedVisit.last_day_daycare}
						visitDate={updatedVisit.visit_date}
						startDate={updatedVisit.startDate}
						relatedPetCareVisit={visit.related_petcare_visit}
						endDate={updatedVisit.type === BOARDING ? updatedVisit.endDate : null}
						save={series}
						isShown={isShown}
						loading={loading}
						setIsShown={setIsShown}
					/>
					<CancelDeleteVisitDialog
						toDelete={updatedVisit.status.id === STATUS_ID.Cancelled}
						isShown={isCancelDeleteDialogShown}
						setIsShown={setIsCancelDeleteDialogIsShown}
						confirmDeletion={() =>
							updatedVisit.status.id !== STATUS_ID.Cancelled ? cancelVisit() : removeVisit()
						}
					/>
					<EditDogsDialog
						isShown={isEditPetsDialogShown}
						visit={updatedVisit}
						pets={household ? household.pets : null}
						setIsShown={setIsEditPetsDialogIsShown}
						editDogsOnVisit={editDogsOnVisit}
						isAddPet={isAddPet}
					/>
					<EditLineItemDialog
						saveVisit={updateVisitPrice}
						isShown={isEditItemPopupShown}
						visit={updatedVisit}
						selectedItem={selectedItem}
						setSelectedItem={setSelectedItem}
						setIsShown={setIsEditItemPopupShown}
					/>
					{updatedVisit?.type === GROOMING && (
						<DuplicateDialog
							facility={facility}
							visit={updatedVisit}
							isShown={duplicateDialog}
							setIsShown={setDuplicateDialog}
							duplicate={duplicateVisit}
						/>
					)}
				</div>
			) : null}
			<RemovedAddOnsDialog
				removed_addons={removedAddons}
				saveVisit={() => {
					gen.next()
					showRemovedAddOnsWarning(false)
					setRemovedAddOns([])
				}}
				isShown={removedAddOnsWarning}
				setIsShown={() => showRemovedAddOnsWarning(!removedAddOnsWarning)}
			/>
			<AddToDropoffPickupQueueDialog
				visit={visit}
				isShown={showAddToDPQueueDialog}
				onClose={() => setShowAddToDPQueueDialog(false)}
			/>
		</Container>
	)
}
export default Visit
